// Minimal error tracker with basic classification
export function classifyError(error) {
  const msg = String(error?.message || '').toLowerCase();
  if (msg.includes('permission') || msg.includes('policy') || error?.code === '42501') return 'permission';
  if (msg.includes('network') || msg.includes('fetch') || msg.includes('timeout')) return 'network';
  if (Array.isArray(error?.cause)) return 'validation';
  return 'unknown';
}

export function captureError(error, context) {
  const category = classifyError(error);
  // Best-effort structured log
  // eslint-disable-next-line no-console
  console.error('[ErrorTracker]', { category, message: error?.message, code: error?.code, status: error?.status, context });
  return { category };
}


